import { Component, ElementRef, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { AppService } from '../core/app.service';
import { SearchService } from '../core/search.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('verifyInput') verifyInput: ElementRef;

  // Verify lookup state
  public verifyValue = '';
  public showResult = false;
  public verifiedName = '';
  public verifiedSpId = '';

  // How It Works state
  public steps = [
    {
      title: 'Verify the Badge',
      desc: 'Search by company name to confirm your mover holds current IAMTrusted status.'
    },
    {
      title: 'Understand What\'s Behind It',
      desc: 'Every IAMTrusted Mover has been vetted by the IAM for licensing, insurance, and compliance based on location and scope of service.'
    },
    {
      title: 'Move with Confidence',
      desc: 'In the unlikely event that anything does go wrong, IAMTrusted\'s Consumer Issue Support System gives you access to a formal, independent resolution process — so you\'re never on your own.'
    }
  ];
  public currentIndex = 0;
  public trackTop = 0;
  public trackHeight = 0;
  public indicatorTop = 0;
  public indicatorHeight = 0;
  public indicatorTransition = 'none';

  private cycleInterval = 6000;
  private timer: any;
  private observer: IntersectionObserver;
  private resizeObserver: any;

  constructor(public service: AppService, public searchService: SearchService, private router: Router, private el: ElementRef) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.initReveals();
    this.layoutRail();
    this.activateStep(0, true);

    if (typeof window !== 'undefined' && 'ResizeObserver' in window) {
      this.resizeObserver = new (window as any).ResizeObserver(() => {
        this.layoutRail();
        this.updateIndicator(this.currentIndex, false);
      });
      this.resizeObserver.observe(this.el.nativeElement);
    }
  }

  ngOnDestroy(): void {
    if (this.timer) clearTimeout(this.timer);
    if (this.observer) this.observer.disconnect();
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }

  private initReveals() {
    if (typeof window !== 'undefined' && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('visible');
            this.observer.unobserve(e.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

      const reveals = this.el.nativeElement.querySelectorAll('.reveal');
      reveals.forEach(el => this.observer.observe(el));
    }
  }

  // --- Verify Lookup ---
  public onInput() {
    this.showResult = false;
  }

  public onClear() {
    this.verifyValue = '';
    this.showResult = false;
    const input = this.el.nativeElement.querySelector('#verify-input');
    if (input) input.focus();
  }

  public onVerify(event: Event) {
    if (event) {
      event.preventDefault();
    }
    const val = this.verifyValue.trim();
    if (!val) return;

    console.log('Verify lookup value', val);
    this.service.getCompany(val, { size: 1 }).subscribe(response => {
      if (response.body && response.body.length > 0) {
        console.log('Verify lookup response', response);
        this.router.navigate(['/result'], { queryParams: { companyName: val } });
        /*
        const item = response.body[0];
        this.verifiedName = item.companylegalname || (item.searchResult && item.searchResult.companylegalname) || val;
        this.verifiedSpId = item.id || (item.searchResult && item.searchResult.id);
        this.showResult = true;
         */
      } else {
        this.router.navigate(['/result'], { queryParams: { companyName: val } });
      }
    }, error => {
      console.error('Verify lookup failed', error);
      this.router.navigate(['/result'], { queryParams: { companyName: val } });
    });
  }

  public viewProfile() {
    if (this.verifiedSpId) {
      this.router.navigate(['/profile', this.verifiedSpId]);
    } else {
      this.router.navigate(['/result'], { queryParams: { companyName: this.verifyValue } });
    }
  }

  public scrollToVerify(event: Event) {
    if (event) {
      event.preventDefault();
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setTimeout(() => {
      const input = this.el.nativeElement.querySelector('#verify-input');
      if (input) input.focus();
    }, 400);
  }

  // --- How It Works Interactor ---
  private layoutRail() {
    const stepsEls = this.el.nativeElement.querySelectorAll('.step');
    if (stepsEls.length < 2) return;

    const firstCircle = stepsEls[0].querySelector('.step-num');
    const lastCircle = stepsEls[stepsEls.length - 1].querySelector('.step-num');

    if (!firstCircle || !lastCircle) return;

    const firstCenter = firstCircle.offsetTop + (firstCircle.offsetHeight / 2);
    const lastCenter = lastCircle.offsetTop + (lastCircle.offsetHeight / 2);

    this.trackTop = firstCenter;
    this.trackHeight = lastCenter - firstCenter;
  }

  public activateStep(index: number, animate: boolean) {
    this.currentIndex = index;
    this.updateIndicator(index, animate);

    clearTimeout(this.timer);
    if (animate) {
      this.timer = setTimeout(() => this.advance(), this.cycleInterval);
    }
  }

  /*
  public searchByCompanyName(): void {
    if (!this.companyName) return;
    const params = {
      companyName: this.companyName,
      size: 10,
      page: 0,
      sort: 'companylegalname,asc'
    };
    this.searchService.search(params);
  }
  */

  /*
  public searchByCompanyName(): void {
    if (!this.verifyValue) return;
    const params = {
      companyName: this.verifyValue,
      size: 10,
      page: 0,
      sort: 'companylegalname,asc'
    };
    this.searchService.search(params);
  }
  */

  private updateIndicator(index: number, animate: boolean) {
    const stepsEls = this.el.nativeElement.querySelectorAll('.step');
    if (!stepsEls[index]) return;

    const circle = stepsEls[index].querySelector('.step-num');
    if (!circle) return;

    const center = circle.offsetTop + (circle.offsetHeight / 2);

    let height = 0;
    if (index < stepsEls.length - 1) {
      const nextCircle = stepsEls[index + 1].querySelector('.step-num');
      const nextCenter = nextCircle.offsetTop + (nextCircle.offsetHeight / 2);
      height = nextCenter - center;
    } else {
      height = (stepsEls[index].offsetTop + stepsEls[index].offsetHeight) - center;
    }

    this.indicatorTop = center;
    this.indicatorHeight = 0;
    this.indicatorTransition = 'none';

    // Force reflow
    void this.el.nativeElement.offsetHeight;

    if (animate) {
      this.indicatorTransition = `height ${this.cycleInterval}ms linear`;
      this.indicatorHeight = height;
    } else {
      this.indicatorHeight = height;
    }
  }

  private advance() {
    const next = (this.currentIndex + 1) % this.steps.length;
    this.activateStep(next, true);
  }
}
